// import React, { useState } from "react";
// import API from "../services/api";
// import "./upload.css";

// function Upload() {
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState("");

//   // 📂 Handle file select
//   const handleFileChange = (e) => {
//     const selectedFile = e.target.files[0];

//     if (!selectedFile) return;

//     // ✅ Validate file type
//     if (
//       !selectedFile.name.endsWith(".xlsx") &&
//       !selectedFile.name.endsWith(".xls")
//     ) {
//       setMessage("❌ Only Excel files allowed");
//       return;
//     }

//     setFile(selectedFile);
//     setMessage("");
//   };

//   // 🚀 Upload file
//   const handleUpload = async () => {
//     if (!file) {
//       setMessage("⚠️ Please select a file first");
//       return;
//     }

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       setLoading(true);
//       setMessage("");

//       // ✅ removed unused 'res'
//       await API.post("/upload/excel", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       setMessage("✅ Upload Successful");
//       setFile(null); // reset after upload
//     } catch (err) {
//       console.log(err);
//       setMessage("❌ Upload Failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="upload-container">

//       {/* 🔥 HEADER */}
//       <div className="upload-header">
//         <h1>📤 Upload Commission Agents</h1>
//         <p>Upload Excel file to add multiple agents</p>
//       </div>

//       {/* 🔥 CARD */}
//       <div className="upload-card">

//         {/* FILE INPUT */}
//         <input
//           type="file"
//           accept=".xlsx, .xls"
//           onChange={handleFileChange}
//         />

//         {/* FILE NAME */}
//         {file && (
//           <p className="file-name">
//             📄 {file.name}
//           </p>
//         )}

//         {/* BUTTON */}
//         <button
//           onClick={handleUpload}
//           disabled={loading}
//         >
//           {loading ? "⏳ Uploading..." : "🚀 Upload File"}
//         </button>

//         {/* MESSAGE */}
//         {message && (
//           <p className="message">
//             {message}
//           </p>
//         )}

//       </div>

//     </div>
//   );
// }

// export default Upload;







import React, { useState, useEffect } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function Upload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();

  // 🖱️ Mouse Tracking for Spotlight Effect
  useEffect(() => {
    const handleMouseMove = (e) => setMousePos({ x: e.clientX, y: e.clientY });
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  // 📂 Handle file select
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.name.endsWith(".xlsx") && !selectedFile.name.endsWith(".xls")) {
      setMessage("❌ Only Excel files (.xlsx, .xls) are allowed");
      setFile(null);
      return;
    }

    setFile(selectedFile);
    setMessage("");
  };

  // 🚀 Upload file
  const handleUpload = async () => {
    if (!file) {
      setMessage("⚠️ Please select a file first");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      setMessage("");

      await API.post("/upload/excel", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setMessage("✅ Database Updated Successfully");
      setFile(null); 
    } catch (err) {
    console.log("UPLOAD ERROR:", err);

    // ✅ Show backend error if available
    if (err.response?.data?.detail) {
      setMessage(`❌ ${err.response.data.detail}`);
    } else {
      setMessage("❌ Upload Failed: Please check file format");
    }

  } finally {
    setLoading(false);
  }
};

  return (
    <div className="upload-page-wrapper">
      <style>{`
        .upload-page-wrapper {
          min-height: 100vh;
          background: #020617;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 20px;
          color: white;
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: relative;
          overflow: hidden;
        }

        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(59, 130, 246, 0.15) 0%, transparent 50%);
          z-index: 1; pointer-events: none;
        }

        /* 📍 FIXED BACK BUTTON - LEFT BOTTOM CORNER */
        .back-btn-fixed {
          position: relative;
          bottom: 22px;
          left: -2px;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #94a3b8;
          padding: 12px 50px;
          border-radius: 14px;
          cursor: pointer;
          font-weight: 700;
          font-size: 14px;
          display: flex;
          width:20rem;
          align-items: center;
          gap: 10px;
          z-index: 100;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .back-btn-fixed:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white;
          transform: translateX(5px);
          border-color: rgba(255, 255, 255, 0.3);
          box-shadow: 0 10px 20px rgba(0,0,0,0.3);
        }

        .upload-header {
          text-align: center;
          margin-bottom: 30px;
          z-index: 2;
        }

        .upload-header h1 {
          font-size: clamp(24px, 5vw, 32px);
          font-weight: 800;
          letter-spacing: -1px;
          margin-bottom: 10px;
          background: linear-gradient(to right, #fff, #94a3b8);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .upload-header p { color: #64748b; font-size: 16px; }

        .upload-card {
          width: 100%;
          max-width: 500px;
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(40px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          padding: 40px;
          border-radius: 32px;
          box-shadow: 0 40px 80px -20px rgba(0,0,0,0.5);
          text-align: center;
          z-index: 2;
        }

        .drop-zone {
          border: 2px dashed rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          padding: 40px 20px;
          margin-bottom: 25px;
          transition: 0.3s;
          position: relative;
        }

        .drop-zone:hover {
          border-color: #fbbf24;
          background: rgba(251, 191, 36, 0.03);
        }

        .drop-zone input {
          position: absolute;
          width: 100%; height: 100%;
          top: 0; left: 0; opacity: 0;
          cursor: pointer;
        }

        .file-name {
          background: rgba(59, 130, 246, 0.1);
          color: #60a5fa;
          padding: 12px;
          border-radius: 12px;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 20px;
          border: 1px solid rgba(59, 130, 246, 0.2);
        }

        .upload-btn {
          width: 100%;
          padding: 16px;
          border-radius: 14px;
          border: none;
          background: #fbbf24;
          color: #020617;
          font-weight: 800;
          font-size: 15px;
          cursor: pointer;
          transition: 0.3s;
        }

        .upload-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(251, 191, 36, 0.3);
        }

        .upload-btn:disabled {
          background: #1e293b;
          color: #475569;
          cursor: not-allowed;
        }

        .vgm-logo-small {
          display: flex; justify-content: center; gap: 4px; margin-bottom: 20px;
        }
        .block {
          width: 12px; height: 12px;
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
        }
      `}</style>

      <div className="spotlight"></div>
      
      {/* 🔹 FIXED BACK BUTTON AT BOTTOM LEFT */}
      <button className="back-btn-fixed" onClick={() => navigate("/dashboard")}>
        <span>←</span> Back to Dashboard
      </button>

      <header className="upload-header">
        <div className="vgm-logo-small">
          <div className="block" style={{background: '#ef4444'}}></div>
          <div className="block" style={{background: '#f59e0b'}}></div>
        </div>
        <h1>Bulk Agent Import</h1>
        <p>Populate your commission agent registry via Excel</p>
      </header>

      <div className="upload-card">
        <div className="drop-zone">
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileChange}
          />
          <div style={{fontSize: '40px', marginBottom: '15px'}}>📊</div>
          <p style={{fontWeight: '700', marginBottom: '5px'}}>
            {file ? "Change File" : "Select Excel File"}
          </p>
          <p style={{fontSize: '12px', color: '#64748b'}}>
            Drag and drop or click to browse
          </p>
        </div>

        {file && <div className="file-name">📄 {file.name}</div>}

        <button
          className="upload-btn"
          onClick={handleUpload}
          disabled={loading || !file}
        >
          {loading ? "⏳ Processing..." : "🚀 Sync to Database"}
        </button>

        {message && (
          <p style={{ marginTop: '20px', fontSize: '14px', fontWeight: '600', color: message.includes('✅') ? '#22c55e' : '#ef4444' }}>
            {message}
          </p>
        )}
      </div>

      <footer style={{position: 'bottom',top:'50px', bottom: '50px',marginTop:'10px', right: '30px', color: '#475569', fontSize: '11px', letterSpacing: '1px'}}>
        SECURE DATA INGESTION PORTAL v2.0
      </footer>
    </div>
  );
}

export default Upload;